import { Form, Input, Modal, Statistic, message } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import { Curl } from "../components/Jarvis";

const calcaluatedAmount = (paymentDetail = []) => {
  console.log(paymentDetail);
  var returnValues = 0;
  Curl.get(
    `/gateway/resources/payments/${paymentDetail.id}/refund/transactions`
  ).then((data) => {
    console.log(data.payload.available_refund_amount);
    console.log(typeof data.payload.available_refund_amount);
    if (typeof data.payload.available_refund_amount == "string") {
      returnValues = data.payload.available_refund_amount;
      console.log(data.payload.available_refund_amount);
    }
    console.log(data.payload.available_refund_amount);
  });
  console.log(returnValues);
  return returnValues;
};

export const RefundModal = (props) => {
  // const calculated = calcaluatedAmount(props.payment);
  const [form] = Form.useForm();
  const [cancelLoading, setCancelLoading] = useState(false);
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 16,
      },
    },
  };

  const { mutate: createRefund, isLoading: isUpdating } = useMutation(
    (formData) => {
      return Curl.post(
        `/gateway/resources/payments/${formData.id}/refund`,
        formData
      )
        .then((res) => {
          // setCancelLoading(false);
          return message.info("Refund Requested");
        })
        .catch((err) => {
          if (typeof err.payload.error.message === "string") {
            message.error(err.payload.error.message);
          } else {
            message.error("Somethings wrong.");
          }
        });
    }
  );

  const handleCreate = () => {
    setCancelLoading(true);
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        createRefund(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
    window.setTimeout(function () {
      window.location.reload();
    }, 1500);
  };

  return (
    <Modal
      open={props.open}
      title="Request refund"
      okText="Ok"
      onCancel={() => props.onCancel()}
      onOk={handleCreate}
      cancelButtonProps={{ disabled: isUpdating }}
      okButtonProps={{ loading: isUpdating }}
      centered
    >
      <Form
        form={form}
        // layout="vertical"
        initialValues={{
          id: props.reference,
        }}
        loading={cancelLoading}
      >
        <Form.Item
          label="id"
          name="id"
          noStyle
          // value={props.reference}
          rules={[
            {
              required: true,
              message: "Please input the title of collection!",
            },
          ]}
        >
          <Input type="hidden" />
        </Form.Item>
        {/* <Form.Item
          label="Payment Amount"
          {...formItemLayout}
        >
          <Statistic
      prefix={props.payment.order_currency}
      value={props.payment.order_amount}
      precision={2}
      style={{ textAlign: "left",fontSize: "16px"}}
      valueStyle={{ color: "#000000e0", textAlign: "left" ,fontSize: "12px"}}
    />
    
        </Form.Item> */}
        {/* <Form.Item
          label="Refunded Amount"
          {...formItemLayout}
        >
          <Statistic
      prefix={props.payment.order_currency}
      value={calculated.refundedAmount}
      precision={2}
      style={{ textAlign: "left",fontSize: "16px"}}
      valueStyle={{ color: "#000000e0", textAlign: "left" ,fontSize: "12px"}}
    />
    
        </Form.Item> */}
        <Form.Item label="Available Refund Amount" {...formItemLayout}>
          <Statistic
            prefix={props.payment.order_currency}
            value={props.payment.available_refund_amount}
            precision={2}
            style={{ textAlign: "left", fontSize: "16px" }}
            valueStyle={{
              color: "#000000e0",
              textAlign: "left",
              fontSize: "12px",
            }}
          />
        </Form.Item>
        <Form.Item
          label="Refund Amount"
          {...formItemLayout}
          name="amount"
          rules={[
            {
              required: true,
              message: "Please input the refund amount!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
